<template>
   <div class="notifications">
      <notification
         v-for="notification in notifications.slice(Math.max(notifications.length - 6, 0))"
         :key="notification.id"
         :notification="notification"
      />
   </div>
</template>

<script>
import notification from '@/core/components/Notification';
import { mapState } from 'vuex';
export default {
   components: {
      notification,
   },

   props: {},

   data() {
      return {};
   },

   created() {},

   mounted() {},

   computed: {
      ...mapState(['notifications']),
   },

   watch: {},

   methods: {},
};
</script>

<style lang="scss" scoped>
.notifications {
   z-index: 100000;
   position: fixed;
   right: 1rem;
   bottom: 1rem;
   &::-webkit-scrollbar {
      visibility: hidden;
   }
}
</style>
